import React, { useState } from 'react';
import UploadFab from './UploadFab';
import ReceiptModal from './ReceiptModal';
import ReceiptNutritionModal from './ReceiptNutritionModal';
import SnackbarComponent from './SnackbarComponent';
import useUploadHandler from '../hooks/useUploadHandler';
import useSnackbar from '../hooks/useSnackbar';
import useReceiptHandler from '../hooks/useReceiptHandler';
import { useAuth } from '../context/AuthContext';

// Reusable upload widget that bundles FAB + modals + snackbar
// Can be dropped on any page to enable receipt/file upload flow
const UploadWidget = () => {
  const { user } = useAuth();
  const { snackbarOpen, snackbarMessage, snackbarSeverity, showSnackbar, handleSnackbarClose } = useSnackbar();

  const [receiptModalOpen, setReceiptModalOpen] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [nutritionModalOpen, setNutritionModalOpen] = useState(false);

  const {
    selectedFile,
    uploadStatus,
    uploadProgress,
    uploadError,
    handleFileSelect,
  } = useUploadHandler(showSnackbar, setReceiptData, setReceiptModalOpen);

  const {
    confirming,
    newItemName,
    setNewItemName,
    newItemPrice,
    setNewItemPrice,
    handleConfirmReceipt,
  } = useReceiptHandler(showSnackbar, receiptData, setReceiptData, setReceiptModalOpen, setNutritionModalOpen);

  // Show upload only for logged-in users
  if (!user) return null;

  return (
    <>
      <UploadFab
        uploadStatus={uploadStatus}
        handleFileSelect={handleFileSelect}
        selectedFile={selectedFile}
        uploadProgress={uploadProgress}
        uploadError={uploadError}
      />

      <ReceiptModal
        open={receiptModalOpen}
        onClose={() => { if (!confirming) setReceiptModalOpen(false); }}
        receiptData={receiptData}
        setReceiptData={setReceiptData}
        confirming={confirming}
        onConfirm={handleConfirmReceipt}
        newItemName={newItemName}
        setNewItemName={setNewItemName}
        newItemPrice={newItemPrice}
        setNewItemPrice={setNewItemPrice}
      />

      <ReceiptNutritionModal
        open={nutritionModalOpen}
        onClose={() => setNutritionModalOpen(false)}
        receiptData={receiptData}
      />

      <SnackbarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </>
  );
};

export default UploadWidget;
